import { makeAutoObservable, runInAction } from 'mobx';

import { filteringController } from "../../MainPage/Controllers/FilteringController";
import { basketController } from "../../../Common/Controllers/BasketController";
import { CourierQuote } from "../../../Common/DTOs/Delivery/CourierShipmentResponseModel";
import { transactionAjaxController } from "../../../Common/Ajax/TransactionAjaxController";
import { TransactionDTO, TransactionResult } from "../../../Common/DTOs/Payment/TransactionDTO";

export type OrderControllerProps = {
  orderController: OrderController
}

export class OrderController {
  private _activeStep = 0;
  selectedQuote: CourierQuote | null = null;
  private _transaction: TransactionDTO | null = null;

  setSelectedQuote(quote: CourierQuote | null) {
    this.selectedQuote = quote;
  }

  get missedIssues() {
    // TODO: we should not be referencing this here
    return filteringController.getFilteredIssuesByCategory("extras")
  }

  get activeStep() {
    return this._activeStep;
  }

  set activeStep(step: number) {
    this._activeStep = step;
  }

  async getTransaction(transactionId: number) {
    const transaction = await transactionAjaxController.getTransaction(transactionId);
    runInAction(() => {
      this._transaction = transaction;
    })
  }

  get transactionSuccessful() {
    return this._transaction != null &&
      (this._transaction.result === TransactionResult.Succeeded || this._transaction.result === TransactionResult.SucceededNoEmail);
  }

  get transaction() {
    return this._transaction;
  }

  isPaymentPossible = () => {
    return this.selectedQuote != null;
  }

  finalizePayment = async () => {
    // ensure we clear the basket after successful transaction
    await basketController.clearBasket();
    await basketController.getBasket();
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const orderController = new OrderController();